import { useCallback } from "react"
import toastError from "../../../errors/toastError"
import api from "../../../services/api"
import useTempMessagesStore from "../../../stores/tempMessage"
import mensagemExtrairId from "../../../utils/mensagemExtrairId"
import { apiMensagemMidiaEnviar } from "../../../helpers/apiMensagemMidiaEnviar"

export const useHandleSendMessage = () => {
  const { updateTempMessage } = useTempMessagesStore()

  const handleSend = useCallback(
    async (
      cMensagemAtual,
      mMidiasAtuais,
      oMensagemReferenciadaAtual,
      nTicketId,
      oMensagemTemp,
      oMensagemEditada,
      setLoading,
      nCanalTipoId,
    ) => {
      if (oMensagemTemp.mensagemIdTemporario) {
        updateTempMessage(oMensagemTemp.mensagemIdTemporario, {
          ack: 1, // Status: enviando
          error: false,
          errorMessage: "",
        })
      }
      try {
        if (mMidiasAtuais?.length > 0) {
          const oFormData = new FormData()
          oFormData.append("fromMe", true)
          oFormData.append(
            "body",
            cMensagemAtual
              ? oMensagemEditada?.assinatura
                ? oMensagemEditada?.assinatura + "\n" + cMensagemAtual.trim()
                : cMensagemAtual.trim()
              : "",
          )
          oFormData.append("mensagemIdTemporario", oMensagemTemp.mensagemIdTemporario)
          oFormData.append("canalTipoId", nCanalTipoId)

          // Garante que apenas o id será enviado
          const oMensagemReferenciadaId = mensagemExtrairId(oMensagemReferenciadaAtual)
          if (oMensagemReferenciadaId) {
            oFormData.append("mensagemReferenciada", JSON.stringify(oMensagemReferenciadaId))
          }

          const oMensagemEditadaId = mensagemExtrairId(oMensagemEditada)
          if (oMensagemEditadaId) {
            oFormData.append("mensagemEditada", JSON.stringify(oMensagemEditadaId))
          }

          if (Array.isArray(mMidiasAtuais)) {
            mMidiasAtuais.forEach((oMedia) => {
              if (oMedia.url) {
                oFormData.append("mediasUrl", JSON.stringify(oMedia))
              } else {
                const oArquivo = oMedia.file || oMedia
                oFormData.append("medias", oArquivo, oArquivo.name || oMedia.name)
              }
            })
          } else {
            if (mMidiasAtuais && mMidiasAtuais.startsWith("blob:")) {
              try {
                const oResponse = await fetch(mMidiasAtuais)
                const oBlob = await oResponse.blob()
                const oFile = new File([oBlob], mMidiasAtuais.name || "file", { type: oBlob.type })
                oFormData.append("medias", oFile)
              } catch (err) {
                console.error("Error converting blob URL to file:", err)
                throw err
              }
            } else if (mMidiasAtuais.url) {
              // Regular URL
              oFormData.append("mediasUrl", JSON.stringify(mMidiasAtuais))
            } else {
              const oArquivo = mMidiasAtuais.file || mMidiasAtuais
              oFormData.append("medias", oArquivo, oArquivo.name || mMidiasAtuais.name)
            }
          }

          const cMetodo = oMensagemEditadaId ? "put" : "post"
          await apiMensagemMidiaEnviar(nTicketId, oFormData, { method: cMetodo })
        } else {
          const oMensagem = {
            mediaUrl: "",
            body: oMensagemEditada?.assinatura
              ? oMensagemEditada?.assinatura + "\n" + cMensagemAtual.trim()
              : cMensagemAtual.trim(),
            mensagemReferenciada: mensagemExtrairId(oMensagemReferenciadaAtual),
            mensagemEditada: mensagemExtrairId(oMensagemEditada),
            mensagemIdTemporario: oMensagemTemp.mensagemIdTemporario,
            canalTipoId: nCanalTipoId,
          }

          // Determina método (PUT para edição, POST para criação) e envia uma única requisição
          const cMetodoJson = oMensagem.mensagemEditada ? "put" : "post"
          await api({ method: cMetodoJson, url: `/messages/${nTicketId}`, data: oMensagem })
        }
      } catch (err) {
        // Em caso de erro, atualiza o status da mensagem temporária
        if (oMensagemTemp?.mensagemIdTemporario) {
          updateTempMessage(oMensagemTemp.mensagemIdTemporario, {
            ack: 0, // Status: erro
            error: true,
            errorMessage: err.message,
          })
        }
        toastError(err)
        throw err // Re-throw para que o componente possa lidar se necessário
      } finally {
        setLoading(false)
      }
    },
    [updateTempMessage],
  )

  return handleSend
}
